import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as AppstoreInAppPurchaseReducer from './appstore-in-app-purchase.reducer';
import {AppstoreInAppPurchaseState} from './appstore-in-app-purchase.reducer';
import {Dictionary} from '@ngrx/entity/src/models';
import {AppstoreInAppPurchase} from './appstore-in-app-purchase.model';
import {IAPProduct} from '@awesome-cordova-plugins/in-app-purchase-2';
import {IN_APP_IOS_SUBSCRIPTION_ID} from '../in-app.model';

export const selectAppstoreInAppPurchaseState =
  createFeatureSelector<AppstoreInAppPurchaseReducer.AppstoreInAppPurchaseState>(
    AppstoreInAppPurchaseReducer.appstoreInAppPurchaseFeatureKey
  );

const {selectIds, selectEntities, selectAll, selectTotal} =
  AppstoreInAppPurchaseReducer.appstoreInAppPurchaseAdapter.getSelectors();

export const selectAllAppstoreInAppPurchases = createSelector(
  selectAppstoreInAppPurchaseState,
  selectAll
);

export const appUserIsStudent = createSelector(
  selectAllAppstoreInAppPurchases,
  (subs: AppstoreInAppPurchase[]): boolean => {
    const owned = subs.find((s: AppstoreInAppPurchase) => s.owned);
    return (
      owned !== undefined &&
      owned !== null &&
      owned.id === IN_APP_IOS_SUBSCRIPTION_ID.STUDENT
    );
  }
);

export const appUserIsMentor = createSelector(
  selectAllAppstoreInAppPurchases,
  (subs: AppstoreInAppPurchase[]): boolean => {
    const owned = subs.find((s: AppstoreInAppPurchase) => s.owned);
    return (
      owned !== undefined &&
      owned !== null &&
      owned.id === IN_APP_IOS_SUBSCRIPTION_ID.MENTOR
    );
  }
);

export const appUserIsTeacher = createSelector(
  selectAllAppstoreInAppPurchases,
  (subs: AppstoreInAppPurchase[]): boolean => {
    const owned = subs.find((s: AppstoreInAppPurchase) => s.owned);
    return (
      owned !== undefined &&
      owned !== null &&
      owned.id === IN_APP_IOS_SUBSCRIPTION_ID.TEACHER
    );
  }
);

export const hasActiveIOSSubscription = createSelector(
  selectAllAppstoreInAppPurchases,
  (subs: AppstoreInAppPurchase[]): boolean => {
    const hasOwned = subs.find((s: AppstoreInAppPurchase) => s.owned);

    return hasOwned !== undefined && hasOwned !== null;
  }
);

export const selectAppstoreInAppPurchaseEntities = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseReducer.AppstoreInAppPurchaseState) =>
    selectEntities(state)
);
export const selectAppstoreInAppPurchaseIds = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseReducer.AppstoreInAppPurchaseState) =>
    selectIds(state)
);
export const selectAppstoreInAppPurchaseTotal = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseReducer.AppstoreInAppPurchaseState) =>
    selectTotal(state)
);

export const selectedAppstoreInAppPurchaseID = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseReducer.AppstoreInAppPurchaseState) =>
    state.selectedAppstoreInAppPurchaseID
);

export const getAppstoreInAppPurchaseByID = (id: string) =>
  createSelector(
    selectAppstoreInAppPurchaseEntities,
    (entities: Dictionary<AppstoreInAppPurchase>) => {
      return entities[id];
    }
  );

export const selectAllIOSProducts = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseState): IAPProduct[] => {
    return Object.values(state.products);
  }
);

export const selectInAppPurchaseCheckOutProgress = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseState) => state.checkoutInProgress
);

export const selectInAppPurchasePurchaseError = createSelector(
  selectAppstoreInAppPurchaseState,
  (state: AppstoreInAppPurchaseState) => state.checkoutInProgress
);
